<template>
  <page>
    <v-flex xs12>
      <form>
        <v-expansion-panel expand :value="[true]">
          <v-expansion-panel-content>
            <div slot="header">
              <v-icon>mdi-filter-variant</v-icon> Filters
            </div>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.name" :label="labels.name" :error-messages="errors.collect('name')" data-vv-name="name" :data-vv-as="labels.name" v-validate="'name|max:60'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.nricPassport" :label="labels.nricPassport" :error-messages="errors.collect('nricPassport')" data-vv-name="nricPassport" :data-vv-as="labels.nricPassport" v-validate="'max:20'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.email" type="email" :label="labels.email" :error-messages="errors.collect('email')" data-vv-name="email" :data-vv-as="labels.email" v-validate="'email'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.mobileNo" v-int-mask="{intScale: 8}" type="tel" :label="labels.mobileNo" :error-messages="errors.collect('mobileNo')" data-vv-name="mobileNo" :data-vv-as="labels.mobileNo" v-validate="'numeric'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.groupName" :label="labels.groupName" :error-messages="errors.collect('groupName')" data-vv-name="groupName" :data-vv-as="labels.groupName" v-validate="'name|max:60'"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </form>
    </v-flex>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <div>
            <div class="headline">Members Listing</div>
          </div>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-data-table v-bind:headers="headers" v-bind:items="items" :total-items="totalItems" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="userId" :loading="loading" :no-data-text="noDataText">
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <span slot="activator">
                {{ props.header.text }}
              </span>
              <span>
                {{ props.header.text }}
              </span>
            </v-tooltip>
          </template>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.name }}</td>
            <td class="text-xs-right">{{ props.item.nricPassport }}</td>
            <td class="text-xs-right">{{ props.item.email }}</td>
            <td class="text-xs-right">{{ props.item.mobileNo }}</td>
            <td class="text-xs-right">{{ props.item.groupName }}</td>
            <td class="text-xs-right">{{ formatBoolean(props.item.acctDisabled) }}</td>
            <td class="text-xs-right">{{ formatDate(props.item.createdDate) }}</td>
            <td class="text-xs-right">
              <table-action :rowData="props" query @query="doQuery" :review="checkAccess(['memberReview'])" @review="doReview"></table-action>
            </td>
          </template>
        </v-data-table>
      </v-card>
      <v-btn slot="activator" color="primary" dark class="mb-2" @click="doNew" v-if="checkAccess(['memberReview'])">
        Add New Member
        <v-icon right>mdi-plus</v-icon>
      </v-btn>
    </v-flex>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import toDate from 'date-fns/toDate'
import { expandURI, filterQuery } from '@/utils/ajax'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      headers: [
        { text: 'Name', align: 'left', value: 'name' },
        { text: 'NRIC/Passport', align: 'right', value: 'nricPassport' },
        { text: 'Email', align: 'right', value: 'email' },
        { text: 'Mobile No.', align: 'right', value: 'mobileNo' },
        { text: 'Member Group', align: 'right', value: 'groupName' },
        { text: 'Acct Disabled', align: 'right', value: 'acctDisabled', sortable: false },
        { text: 'Created Date', align: 'right', value: 'createdDate', sortable: false },
        TableConst.tableActionHeader
      ],
      labels: {
        name: 'Name',
        email: 'Email',
        mobileNo: 'Mobile No.',
        nricPassport: 'NRIC/Passport',
        groupName: 'Member Group'
      },
      filters: {
        name: null,
        nricPassport: null,
        email: null,
        mobileNo: null,
        groupName: null
      },
      totalItems: 0
    }
  },
  mounted() {
    this.fetchData(true)
  },
  methods: {
    async fetchData(options) {
      const apiUrl = this.$store.state.adminMember.menu.membersList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: rowsPerPage,
            options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), this.filters, this.pagination.sortBy, this.pagination.descending))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((user) => {
                const convertUser = {
                  id: user.userId,
                  name: user.name,
                  email: user.email,
                  nricPassport: user.nricPassport,
                  mobileNo: user.mobileNo,
                  groupName: user.groupName,
                  acctDisabled: user.acctDisabled,
                  createdDate: toDate(user.createdDate)
                }
                this.items.push(convertUser)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    doClearFilters() {
      this.filters.name = null
      this.filters.nricPassport = null
      this.filters.email = null
      this.filters.mobileNo = null
      this.filters.groupName = null
      this.fetchData(false)
    },
    doQuery(data) {
      if (data && data.item && data.item.id) {
        this.$router.push({ name: 'memberQuery', params: { id: data.item.id } })
      }
    },
    doReview(data) {
      if (data && data.item && data.item.id) {
        this.$router.push({ name: 'memberDet', params: { id: data.item.id } })
      }
    },
    doNew() {
      this.$router.push({ name: 'memberDet', params: { id: 'new' } })
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending'(value) {
      this.fetchData(false)
    },
    'pagination.page'(value) {
      this.fetchData(false)
    },
    'pagination.rowsPerPage'(value) {
      this.fetchData(false)
    },
    'pagination.sortBy'(value) {
      this.fetchData(false)
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>
</style>
